import api from "../../config/base";
import {
  FETCH_RESOURCES_SUCCESS,
  FETCH_RESOURCES_ERROR,
  FETCH_RESOURCE_SUCCESS,
  FETCH_RESOURCE_ERROR,
  CREATE_RESOURCE_SUCCESS,
  CREATE_RESOURCE_ERROR,
  UPDATE_RESOURCE_SUCCESS,
  UPDATE_RESOURCE_ERROR,
  DELETE_RESOURCE_SUCCESS,
  DELETE_RESOURCE_ERROR,
} from "./types";

// Get all resources
export const fetchResources = () => async (dispatch) => {
  try {
    const res = await api.get('/resources');
    dispatch({
      type: FETCH_RESOURCES_SUCCESS,
      payload: res.data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_RESOURCES_ERROR,
      payload: error.message,
    });
  }
};

// Get a resource by ID
export const fetchResourceById = (id) => async (dispatch) => {
  try {
    const res = await api.get(`/resources/${id}`);
    dispatch({
      type: FETCH_RESOURCE_SUCCESS,
      payload: res.data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_RESOURCE_ERROR,
      payload: error.message,
    });
  }
};

// Create a new resource
export const createResource = (resource) => async (dispatch) => {
  try {
    const res = await api.post('/resources', resource);
    dispatch({
      type: CREATE_RESOURCE_SUCCESS,
      payload: res.data,
    });
    dispatch(fetchResources()); // Fetch updated resources
  } catch (error) {
    dispatch({
      type: CREATE_RESOURCE_ERROR,
      payload: error.message,
    });
  }
};

// Update a resource by ID
export const updateResource = (id, resource) => async (dispatch) => {
  try {
    const res = await api.put(`/resources/${id}`, resource);
    dispatch({
      type: UPDATE_RESOURCE_SUCCESS,
      payload: res.data,
    });
    dispatch(fetchResources()); // Fetch updated resources
  } catch (error) {
    dispatch({
      type: UPDATE_RESOURCE_ERROR,
      payload: error.message,
    });
  }
};

// Delete a resource by ID
export const deleteResource = (id) => async (dispatch) => {
  try {
    await api.delete(`/resources/${id}`);
    dispatch({
      type: DELETE_RESOURCE_SUCCESS,
      payload: id,
    });
    dispatch(fetchResources()); // Fetch updated resources
  } catch (error) {
    dispatch({
      type: DELETE_RESOURCE_ERROR,
      payload: error.message,
    });
  }
};
